import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  chartContainer: {
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@media print": {
      marginBottom: 30,
    },
  },
  chartLegend: { paddingTop: 20 },
}));
